
import Vue, { PropType } from "vue";
import { TranslateResult } from "vue-i18n";

export default Vue.extend({
  name: "ResetPasswordHeader",
  props: {
    description: {
      type: String as PropType<TranslateResult>,
      required: true
    },
    title: {
      type: String as PropType<TranslateResult>,
      required: true
    }
  }
});
